import { render } from "./EventDomainSnippet.vue?vue&type=template&id=65cb733c&scoped=true"
import script from "./EventDomainSnippet.vue?vue&type=script&lang=js"
export * from "./EventDomainSnippet.vue?vue&type=script&lang=js"

import "./EventDomainSnippet.vue?vue&type=style&index=0&id=65cb733c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cb733c"]])

export default __exports__